/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Generate_SectionInputs */

const cs_blog_ai_generate_section = /** @type {(inputs: Blog_Ai_Generate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat návrh`)
};

const en_blog_ai_generate_section = /** @type {(inputs: Blog_Ai_Generate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate draft`)
};

/**
* | output |
* | --- |
* | "Generate draft" |
*
* @param {Blog_Ai_Generate_SectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_generate_section = /** @type {((inputs?: Blog_Ai_Generate_SectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Generate_SectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_generate_section(inputs)
	return cs_blog_ai_generate_section(inputs)
});